module.exports = __webpack_public_path__ + "img/th.2b7bea61.png";